import React, { useState, useEffect } from "react"
import { useNavigate, Link, Navigate } from "react-router-dom"
import Axios from "axios"
import { getCourts } from '../common/api';
import listStates from "../common/listStates";
import ReactInputDateMask from 'react-input-date-mask';
import InputMask from "react-input-mask";
import axios from "axios";
import { useUserActions } from "../actions/user.actions";
import { authAtom } from "../state"
import { useRecoilValue } from 'recoil'
import { ExclamationCircleIcon } from "@heroicons/react/solid"
import { resetCourse } from "../common/api";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const isValidDob = (dob) => {
	if (dob.length !== 10) return false
	const parts = dob.split('/')
	if (parts.length !== 3 || parts[2].length !== 4) return false
	const [month, day, year] = parts.map(Number)
	const date = new Date(year, month - 1, day)
	return (
		date.getFullYear() === year &&
		date.getMonth() === month - 1 &&
		date.getDate() === day
	)
}

export default function Register() {

	const [ error, setError ] = useState(false)
	const [ loading, setLoading ] = useState(false)
	const [ courts, setCourts ] = useState([]);
  const [ existingStudentId, setExistingStudentId ] = useState(null)

	const auth = useRecoilValue(authAtom)

	const userActions = useUserActions()

	const [ inputErrors, setInputErrors ] = useState(new Set())

	const [ studentData, setStudentData ] = useState({
		email: '',
		dl_number: '',
		first_name: '',
		last_name: '',
		address: '',
		city: '',
		state: '',
		zip: '',
		dob: '',
		court: ''
	})

	const navigate = useNavigate()

	const handleChange = (e) => {
		const value = e.target.value

		setStudentData({
			...studentData,
			[e.target.name]: value
		});
	};

	const fieldClass = (field) =>
		`appearance-none block w-full px-3 py-2 border ${
			inputErrors.has(field) ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300'
		} rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`

	const selectClass = (field) =>
		`mt-1 block w-full pl-3 pr-10 py-2 text-base ${
			inputErrors.has(field) ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300'
		} focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md`

	const handleRegister = async (e) => {
    e.preventDefault()

    const trimmedEmail = studentData.email.trim()

    let currentErrors = []
    if (!studentData.first_name.trim()) currentErrors.push('first_name')
    if (!studentData.last_name.trim()) currentErrors.push('last_name')
    if (!trimmedEmail || !EMAIL_REGEX.test(trimmedEmail)) currentErrors.push('email')
    if (!studentData.dl_number) currentErrors.push('dl_number')
    if (!isValidDob(studentData.dob)) currentErrors.push('dob')
    if (!studentData.address) currentErrors.push('address')
    if (!studentData.city) currentErrors.push('city')
    if (!studentData.state) currentErrors.push('state')
    if (!studentData.zip) currentErrors.push('zip')
    if (!studentData.court) currentErrors.push('court')

    if (currentErrors.length > 0) {
      setInputErrors(new Set(currentErrors))
      return false
    }

    setInputErrors(new Set())
    setLoading(true)

    try {
      const res = await axios.post('/register/student', { ...studentData, email: trimmedEmail })
      navigate('/pay', { state: { studentId: res.data.studentId }, replace: true })
      return true
    } catch (err) {
      setError(true)
      setExistingStudentId(err.response?.data?.studentId)
      setLoading(false)
      return false
    }
  }

  const reRegister = async (e) => {
    e.preventDefault()
    try {
      await resetCourse(existingStudentId)
      const mockEvent = { preventDefault: () => {} }
      const success = await handleRegister(mockEvent)
      if (success) {
        setError(false)
      }
    } catch (err) {
      console.error('Reset/Register error:', err)
      setLoading(false)
    }
  }

	useEffect(() => {

		getCourts()
		.then((courts) => {
			setCourts((courts))
		})
		.catch((err) => {
			console.log(err)
			alert('error getting court list')
		})

	}, []);

	if (auth?.id) return <Navigate to='/' />

	return (
		<>
			<div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
				<div className="sm:mx-auto sm:w-full sm:max-w-md">
					<img
						className="mx-auto h-12 w-auto"
						src="https://sd-site-assets-1.s3.us-west-1.amazonaws.com/images/620d71fcf708f14d9e5d4c46_sd-logo.png"
						alt="Workflow"
					/>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Create your account</h2>
					<p className="mt-2 text-center text-sm text-gray-600">
						Or{' '}
						<Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500">
							click here to sign in
						</Link>
					</p>
				</div>

				<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-xl">
					<div className="bg-white py-8 px-4 shadow-md sm:rounded-lg sm:px-10">
						<form className="space-y-6">


							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
								<div className="sm:col-span-3">
									<label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
										First name
									</label>
									<div className="mt-1">
										<input
											id="first_name"
											name="first_name"
											type="text"
											required
											placeholder="John"
											value={studentData.first_name}
											onChange={handleChange}
											className={fieldClass('first_name')}
										/>
									</div>
								</div>

								<div className="sm:col-span-3">
									<label htmlFor="last_name" className="block text-sm font-medium text-gray-700">
										Last name
									</label>
									<div className="mt-1">
										<input
											id="last_name"
											name="last_name"
											type="text"
											required
											placeholder="Doe"
											value={studentData.last_name}
											onChange={handleChange}
											className={fieldClass('last_name')}
										/>
									</div>
								</div>

								<div className="sm:col-span-6">
									<label htmlFor="email" className="block text-sm font-medium text-gray-700">
										Email address
									</label>
									<div className="mt-1">
										<input
											id="email"
											name="email"
											type="text"
											required
											placeholder="johndoe@gmail.com"
											value={studentData.email}
											onChange={handleChange}
											className={fieldClass('email')}
										/>
									</div>
								</div>

								<div className="sm:col-span-3">
									<label htmlFor="dl_number" className="block text-sm font-medium text-gray-700">
										Driver's License Number
									</label>
									<div className="mt-1">
										<input
											id="dl_number"
											name="dl_number"
											type="text"
											required
											placeholder="639286738"
											value={studentData.dl_number}
											onChange={handleChange}
											className={fieldClass('dl_number')}
										/>
									</div>
								</div>

								<div className="sm:col-span-3">
									<label htmlFor="dob" className="block text-sm font-medium text-gray-700">
										Date of Birth
									</label>
									<div className="mt-1">
										<InputMask
											mask='99/99/9999'
											maskPlaceholder={null}
											id="dob"
											name="dob"
											type="text"
											required
											placeholder="07/13/1998"
											value={studentData.dob}
											onChange={handleChange}
											className={fieldClass('dob')}
										/>
									</div>
								</div>

								<div className="sm:col-span-6">
									<label htmlFor="address" className="block text-sm font-medium text-gray-700">
										Address
									</label>
									<div className="mt-1">
										<input
											id="address"
											name="address"
											type="text"
											required
											placeholder="1873 White River Way"
											value={studentData.address}
											onChange={handleChange}
											className={fieldClass('address')}
										/>
									</div>
								</div>

								<div className="sm:col-span-2">
									<label htmlFor="city" className="block text-sm font-medium text-gray-700">
										City
									</label>
									<div className="mt-1">
										<input
											id="city"
											name="city"
											type="text"
											required
											placeholder="Salt Lake City"
											value={studentData.city}
											onChange={handleChange}
											className={fieldClass('city')}
										/>
									</div>
								</div>

								<div className="sm:col-span-2">
									<label htmlFor="state" className="block text-sm font-medium text-gray-700">
										State
									</label>
									<div className="mt-1">
										<select
											id="state"
											name="state"
											className={selectClass('state')}
											value={studentData.state}
											onChange={handleChange}
										>
											{
												listStates().map(s => (
													<option key={s} val={s}>{s}</option>
												))
											}
										</select>
									</div>
								</div>

								<div className="sm:col-span-2">
									<label htmlFor="zip" className="block text-sm font-medium text-gray-700">
										Zip
									</label>
									<div className="mt-1">
										<input
											id="zip"
											name="zip"
											type="text"
											required
											placeholder="84111"
											className={fieldClass('zip')}
											value={studentData.zip}
											onChange={handleChange}
										/>
									</div>
								</div>

								<div className="sm:col-span-6">
									<label htmlFor="court" className="block text-sm font-medium text-gray-700">
										Court
									</label>
									<div className="mt-1">
										<select
											id="court"
											name="court"
											className={selectClass('court')}
											value={studentData.court}
											onChange={handleChange}
											required
										>
											<option value="" disabled selected>Select a court...</option>
											{
												courts.map(c => (
													<option
														key={c.id}
														value={c.id}
													>
														{c.name}
													</option>
												))
											}
										</select>
									</div>
								</div>



							</div>

							<div>
								<button
									onClick={handleRegister}
									disabled={loading}
									type="button"
									className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
								>
									{ loading ? 'Loading...' : 'Register' }
								</button>
							</div>

							{
								error &&
								<div className="w-screen mt-0 h-screen absolute top-0 left-0 bg-black/80 flex justify-center items-center"
                  style={{marginTop: '0px'}}
                >
                  <div className="bg-white rounded-lg p-12 max-w-[600px]">
                    <div className="flex gap-3 items-center text-indigo-600">
                      <ExclamationCircleIcon width={40}/>
                      <p className="font-bold text-lg">Important Notice</p>
                    </div>
                    <div className="mt-4">
                      <p className="text-gray-700">We noticed that you already have an account registered with this email or driver's license.</p>
                      <p className="text-gray-600 mt-3">Creating a new account will replace your existing one. Please note that your previous course progress and information will not be transferred.</p>
                      <details>
                        <summary className="text-blue-700 mt-3 text-sm cursor-pointer">When should I create a new account?</summary>
                        <p className="text-gray-600 mt-3">
                          You may want to create a new account if:
                        </p>
                        <ul className="list-disc ml-6 mt-2 text-gray-600 space-y-2">
                          <li>You need to retake the course after some time has passed</li>
                          <li>You've changed courts and need to update your information</li>
                        </ul>
                      </details>
                      <div className="flex gap-3 mt-6">
                        <button className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md">Cancel</button>
                        <button
                          onClick={reRegister}
                          className="px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 rounded-md">
                          Continue and Register
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
							}

							{
								inputErrors.size > 0 &&
								<div className="rounded-md bg-red-50 p-4">
									<ul className="text-red-700 text-sm space-y-1 list-disc list-inside">
										{inputErrors.has('first_name') && <li>First name is required</li>}
										{inputErrors.has('last_name') && <li>Last name is required</li>}
										{inputErrors.has('email') && <li>Please enter a valid email address (no spaces allowed)</li>}
										{inputErrors.has('dl_number') && <li>Driver's license number is required</li>}
										{inputErrors.has('dob') && <li>Please enter a complete date of birth in MM/DD/YYYY format</li>}
										{inputErrors.has('address') && <li>Address is required</li>}
										{inputErrors.has('city') && <li>City is required</li>}
										{inputErrors.has('state') && <li>State is required</li>}
										{inputErrors.has('zip') && <li>Zip code is required</li>}
										{inputErrors.has('court') && <li>Please select a court</li>}
									</ul>
								</div>
							}


						</form>
					</div>
				</div>
			</div>
		</>
	)
}
